import { render, staticRenderFns } from "./FileBoxDialog.vue?vue&type=template&id=7161877b&scoped=true&"
import script from "./FileBoxDialog.vue?vue&type=script&lang=js&"
export * from "./FileBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./FileBoxDialog.vue?vue&type=style&index=0&id=7161877b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161877b",
  null
  
)

export default component.exports